import { createGlobalStyle } from "styled-components"
import { Theme } from "../theme"
import { markedTextStyles } from "./common/general-styles.component"
import { rawLinkStyles } from "../ui/components/link/link.component"

const GlobalStyle = createGlobalStyle<{ $isDark?: boolean }>`
 @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
  html {
    line-height: 1.5;
    font-size: 16px;
    -moz-font-smoothing: antialiased;
    text-rendering: geometricPrecision;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: ${({ theme }) => theme.font.basic};
  }

  .inline-code {
    display: inline;
    color: #f7f7f7;
    cursor: pointer;
    font-size: 14px;
    font-weight: 900;
  }

  body{
    overflow-x: hidden;

    background: ${({ $isDark }) =>
      $isDark ? "linear-gradient(to top,#fff 90%, #1c1c1c 90%)" : "white"};
      @media(min-width: ${({ theme }) => theme.breakpoint.tablet}px){
        background: ${({ $isDark }) =>
          $isDark ? "linear-gradient(to top,#fff 80%, #1c1c1c 80%)" : "white"};
      }
    
      .CookieDeclaration{
        --max-width: 1260px;
        width: calc(100% - 40px);
        max-width: var(--max-width);
        margin: auto;

        @media (max-width: 768px){
          margin-top: 2rem;
        }
      }
  }

  p, li {
    margin: 0;
    font-weight: 400;
    line-height: 2em;
    font-size: ${14 / 16}rem;
    color: ${({ theme }: { theme: Theme }) => theme.color.text};

    @media (min-width: ${({ theme }: { theme: Theme }) =>
      theme.breakpoint.tabletHorizontal}px) {
      font-size: 1rem;
    }

    & + p {
      margin-top: 1.5em;
    }

    u {
      ${markedTextStyles};
    }

    a {
      ${rawLinkStyles};
    }
  }

  svg{
    @media(max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px){
      max-width: 80%;
    }
  }

  strong {
    font-weight: 500;
  }
`

export default GlobalStyle
